var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5898 6.92969L7.82031 1.16016C7.60156 0.941406 7.19141 0.75 6.89062 0.75H1.3125C0.574219 0.75 0 1.35156 0 2.0625V7.66797C0 7.96875 0.164062 8.37891 0.382812 8.59766L6.15234 14.3672C6.67188 14.8867 7.51953 14.8867 8.01172 14.3672L13.5898 8.78906C14.1094 8.29688 14.1094 7.44922 13.5898 6.92969ZM12.9883 8.1875L7.41016 13.7656C7.21875 13.9297 6.94531 13.9297 6.78125 13.7656L0.984375 7.96875C0.929688 7.88672 0.875 7.75 0.875 7.66797V2.0625C0.875 1.84375 1.06641 1.625 1.3125 1.625H6.89062C7 1.625 7.10938 1.67969 7.19141 1.76172L12.9883 7.55859C13.1523 7.72266 13.1523 7.99609 12.9883 8.1875ZM3.9375 4.14062C4.23828 4.14062 4.48438 4.38672 4.48438 4.6875C4.48438 5.01562 4.23828 5.23438 3.9375 5.23438C3.60938 5.23438 3.39062 5.01562 3.39062 4.6875C3.39062 4.38672 3.60938 4.14062 3.9375 4.14062ZM3.9375 3.375C3.19922 3.375 2.625 3.97656 2.625 4.6875C2.625 5.42578 3.19922 6 3.9375 6C4.64844 6 5.25 5.42578 5.25 4.6875C5.25 3.97656 4.64844 3.375 3.9375 3.375Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.0286bc4e.svg";
export { ForwardRef as ReactComponent };